import Container from "./src/pageContainer.vue";
const YwContainer = {
	name: "YwContainer",
	install(Vue) {
		Vue.component(Container.name, Container);
	},
};

export default YwContainer;
